import { useEffect, useRef } from 'react';
import useTrackEvent from './useTrackEvent';

const useWatchConnect = (account: Record<string, any> | undefined) => {
  const prevAccountRef = useRef(account);
  const trackEvent = useTrackEvent();

  useEffect(() => {
    // If the account goes from null to non-null it means we've gone from disconnected to connected
    if (prevAccountRef.current == null && account) {
      trackEvent('wallet_connected', { method: 'Rainbow Connect', value: 1 });
    }

    prevAccountRef.current = account;
  }, [account, trackEvent]);
};

export default useWatchConnect;
